import { createRef, Component } from "react";
import { isEqual, isEqualWith } from "lodash-es";

import { webix } from "extensions/webix";

export class Webix extends Component {
    constructor(props) {
        super(props);
        this.webixRoot = createRef();
    }
    
    componentDidMount() {
        this.ui = webix.ui(this.props.ui, this.webixRoot.current);
        this.componentDidUpdate(this.props);
    
        if (this.props.data && Array.isArray(this.props.data.spans)) {
            this.props.data.spans.forEach(([start, column, width, height, content, css]) => this.ui.addSpan(start, column, width, height, content, css));
            this.ui.refresh();
        }
    }
    
    // We should not update webix component if previous data is the same as new data
    // Revise this assumption later if we should update the component
    shouldComponentUpdate(nextProps) {
        return !isEqualWith(this.props.data, nextProps.data, isEqual);
    }
    
    componentDidUpdate(prevProps) {
        if (this.props.data) {
            // Webix mutates data here...
            this.setWebixData((this.props.data.data || this.props.data).map((d) => ({ ...d })));
        }
        
        if (this.props?.data?.select) {
            this.select(this.props.data.select);
        }
    }
    
    componentWillUnmount() {
        if (this.ui) {
            this.ui.destructor();
            this.ui = null;
        }
    }
    
    setWebixData(data) {
        if (this.ui.setValues) {
            this.ui.setValues(data);
        } else if (this.ui.parse) {
            let scrollState;
            if (this.props.preserveScrollState) {
                scrollState = this.ui.getScrollState();
            }
            
            this.ui.clearAll(data);
            this.ui.parse(data);
            
            if (this.props.preserveScrollState) {
                // Wrapping in requestAnimationFrame to resolve a race condition
                requestAnimationFrame(() => {
                    // Preserve filters if any applied
                    this.ui?.filterByAll();
                    // Preserve scroll state of the widget
                    this.ui?.scrollTo(scrollState.x, scrollState.y);
                });
            }
        } else if (this.ui.setValue) {
            this.ui.setValue(data);
        }
    }
    
    getWebixElement() {
        return this.ui;
    }
    
    render() {
        return (
            <div className={this.props.className} ref={this.webixRoot}/>
        );
    }
}
